import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { Timestamp } from '@ngx-grpc/well-known-types';
import {
  FollowRequest,
  GetFollowRequestsResponse,
} from 'generated/src/main/proto/api/follow-service.pb';
import { BehaviorSubject, Observable } from 'rxjs';
import { FollowService } from '../services/follow/follow.service';

export class FollowRequestDataSource extends DataSource<FollowRequest> {
  private followerSubject = new BehaviorSubject<readonly FollowRequest[]>([]);
  private paginator: MatPaginator | undefined;
  private readTime: Timestamp | undefined;

  constructor(private followService: FollowService) {
    super();
  }

  setPaginator(paginator: MatPaginator) {
    this.paginator = paginator;

    // Load initial page.
    this.loadPage(paginator.pageIndex * paginator.pageSize, paginator.pageSize);

    // Subscribe to requests for subsequent pages.
    paginator.page.subscribe((pageEvent) =>
      this.loadPage(
        pageEvent.pageIndex * pageEvent.pageSize,
        pageEvent.pageSize,
      ),
    );
  }

  connect(): Observable<readonly FollowRequest[]> {
    return this.followerSubject.asObservable();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  disconnect(): void {}

  reload() {
    this.readTime = undefined;
    if (this.paginator) {
      this.loadPage(
        this.paginator.pageIndex * this.paginator.pageSize,
        this.paginator.pageSize,
      );
    }
  }

  private loadPage(index: number, count: number): void {
    this.followService
      .getFollowRequests(index, count, this.readTime)
      .then((r: GetFollowRequestsResponse) => {
        this.readTime = r.readTime;
        return this.followerSubject.next(r.requests!);
      });
  }
}
